import { render, staticRenderFns } from "./GroupDropdownMenu.vue?vue&type=template&id=153785aa&scoped=true&"
import script from "./GroupDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./GroupDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./GroupDropdownMenu.vue?vue&type=style&index=0&id=153785aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153785aa",
  null
  
)

export default component.exports